import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '../components/LazyRoute'
import { SimplePageLoader } from '@/components/ui/page-loader'

export const Route = createFileRoute('/$')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/NotFoundPage')}
      fallback={<SimplePageLoader />}
    />
  ),
})
